import React from "react";

import { Box, Grid, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";

import OverrideDatePanel from "../components/OverrideDatePanel";
import ScheduleListItem from "../components/ScheduleListItem";
import { useSchedule } from "../SchedulerProvider";

const ScheduleListView: React.FC = observer(() => {
  const schedule = useSchedule();
  const wdayRules = schedule.wdayRules;

  return (
    <Box sx={{ flexGrow: 1, paddingTop: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={8} md={8}>
          <Box
            sx={{ backgroundColor: "#fff" }}
            display="flex"
            flexDirection="column"
            alignItems="center"
            padding={4}
          >
            <div
              style={{
                display: "block",
                alignSelf: "start",
                marginBottom: 21,
              }}
            >
              <Typography variant="body1" fontWeight="700">
                Set your weekly hours
              </Typography>
            </div>
            {wdayRules.map((rule, index: number) => (
              <ScheduleListItem key={index} wday={rule.wday} rule={rule} />
            ))}
          </Box>
        </Grid>
        <Grid item xs={4} md={4}>
          <Box
            sx={{ backgroundColor: "#fff", height: "100%", padding: 4 }}
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <OverrideDatePanel />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
});

export default ScheduleListView;
